import * as React from "react";
import {
  AppBar,
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Checkbox,
  FormGroup,
  Card,
  getImageListItemBarUtilityClass,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import { useNavigate, useLocation, json } from "react-router-dom";
import axios from "axios";
import TablePagination from '@mui/material/TablePagination';
import { configure } from "../../config";
import ApiService from "./../../ApiService";



const Dashboard = () => {
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [productAccess, setProductAccess] = useState({
    ddSEQ: false,
    Genesis: false,
    Sequoia: false,
  });
  var user = JSON.parse(sessionStorage.getItem("userProfile"));
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      'Content-Type': 'application/json',
      "Access-Control-Allow-Methods": "*"
    },
  };
  var idToken = JSON.parse(sessionStorage.getItem("accessToken"));
  useEffect(() => {
    postData();
  }, []);
  const handleProductChange = (product) => {
    setProductAccess((prevState) => ({
      ...prevState,
      [product]: !prevState[product],
    }));
  };
  const handleNameClick = async (email) => {
    const filterReq = JSON.stringify({
      Email: email
    })
    config.headers.Authorization = "Bearer " + idToken.jwtToken;
    const response = await fetch(`${configure.backendUrl}/filterusers`, {
      method: 'POST',
      body: filterReq,
      headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
    });
    const responseFilter = await response.json();
    if(responseFilter && response.status === 200)
    {
      const testData1 = responseFilter;
      setFilteredUsers(testData1)
      console.log(testData1);
      navigate('/createuser', { state: testData1 });
    }
    else {
      navigate('/login');
    }
  };

  const postData = async () => {
    setIsLoading(true);
    const usercheck = JSON.stringify({
      Email: ""
    });
    config.headers.Authorization = "Bearer " + idToken.jwtToken;
    const response = await fetch(`${configure.backendUrl}/filterusers`, {
      method: 'POST',
      body: usercheck,
      headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
    });
    const responseFilter = await response.json();
    if(responseFilter && response.status === 200)
    {
      const testData = responseFilter;
      console.log(testData);
      const selectedProducts = Object.keys(productAccess).filter(
        (product) => productAccess[product]
      );
      const normalizedUsers = testData.map((user) => ({
        Username: user.Username || "N/A",
        "custom:Admin_Access": user["custom:Admin_Access"] || "N/A",
        email_verified: user.email_verified || "N/A",
        nickname: user.nickname || "N/A",
        "custom:Genesis": user["custom:Genesis"] || "N/A",
        "custom:Sequoia": user["custom:Sequoia"] || "N/A",
        given_name: user.given_name || "N/A",
        "custom:ddSEQ": user["custom:ddSEQ"] || "N/A",
        email: user.email || "N/A",
        company_name: user.company_name || "N/A",
      }));
      const filteredData = normalizedUsers.filter((user) => {
        const userDDSEQ = user["custom:ddSEQ"].toLowerCase() === "true";
        const userGenesis = user["custom:Genesis"].toLowerCase() === "true";
        const userSequoia = user["custom:Sequoia"].toLowerCase() === "true";
        const isDDSEQSelected = productAccess.ddSEQ;
        const isGenesisSelected = productAccess.Genesis;
        const isSequoiaSelected = productAccess.Sequoia;
        return (
          (!isDDSEQSelected || (isDDSEQSelected && userDDSEQ)) &&
          (!isGenesisSelected || (isGenesisSelected && userGenesis)) &&
          (!isSequoiaSelected || (isSequoiaSelected && userSequoia)) &&
          user["nickname"].toLowerCase().includes(company.toLowerCase()) &&
          user["Username"].toLowerCase().includes(name.toLowerCase()) &&
          user["email"].toLowerCase().includes(email.toLowerCase())
        );
      });
      setFilteredUsers(filteredData);
      setIsLoading(false);
    }
    else {
      navigate('/login');
    }
  };

  const handleClearFields = () => {
    setName("");
    setCompany("");
    setEmail("");
    setProductAccess({
      ddSEQ: false,
      Genesis: false,
      Sequoia: false
    })
    setPage(0);
    setRowsPerPage(10);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedUsers = filteredUsers.slice(
    page * rowsPerPage, page * rowsPerPage + rowsPerPage
  )


  return (
    <div>
      <Card sx={{ minWidth: 575, height: "85vh" }}>
        <Box sx={{ display: "flex", flexDirection: "column", marginTop: 1.5 }}>
          <Box sx={{ display: "flex" }}>
            <Box p={1} sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                size="small"
                placeholder="Name"
                value={name}
                onChange={(event) => setName(event.target.value)}
                inputProps={{
                  style: {
                    height: "12px",

                    fontSize: "14px",

                    width: "17vw",

                    padding: "10px 14px 8px 14px",
                  },
                }}
              />
            </Box>

            <Box p={1} sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                size="small"
                placeholder="Company"
                value={company}
                onChange={(event) => setCompany(event.target.value)}
                // sx={{ width: "82%" }}
                inputProps={{
                  style: {
                    height: "12px",

                    fontSize: "14px",
                    width: "17vw",

                    padding: "10px 14px 8px 14px",
                  },
                }}
              />
            </Box>

            <Box p={1} sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                size="small"
                placeholder="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                // sx={{ width: "96%" }}
                style={{ marginLeft: 1 }}
                inputProps={{
                  style: {
                    height: "12px",

                    fontSize: "14px",
                    width: "17vw",

                    padding: "10px 14px 8px 14px",
                  },
                }}
              />
            </Box>
          </Box>

          <Box>
            <FormGroup row>
              <Typography variant="h6" sx={{ marginLeft: 1, marginTop: 0.5 }}>
                Product Access:
              </Typography>

              {Object.keys(productAccess).map((product) => (
                <div
                  key={product}

                >
      
                  <Checkbox
                    id={product}
                    checked={productAccess[product]}
                    onChange={() => handleProductChange(product)}
                  ></Checkbox>

                  <label htmlFor={product}>{product}</label>
                </div>
              ))}


              <Box p={1} sx={{ alignContent: "center", marginLeft: 65, marginRight: 0.4 }}>
                <Button sx={{ width: 20, color: '#fff', bgcolor: '#2962ff' }} onClick={postData} startIcon={<SearchIcon sx={{ marginLeft: 1 }} />} disabled={isLoading} />
                <Button variant="contained" color="primary" sx={{ width: 20, marginLeft: 1, color: '#fff', bgcolor: '#2962ff' }} onClick={() => handleClearFields()} >Clear</Button>

              </Box>

            </FormGroup>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",

            flexDirection: "row",

            border: 0.5,

            borderColor: "text.secondary",
          }}
        />

        <Box
          p={1}
          sx={{ display: "flex", flexDirection: "column", marginBottom: 50 }}
        >
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ height: "56vh" }}>
              <Table
                stickyHeader={true}
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow style={{ textAlign: "center" }}>
                    <TableCell align="left">
                      <b>Name</b>
                    </TableCell>

                    <TableCell align="left">
                      <b>Company</b>
                    </TableCell>

                    <TableCell align="left">
                      <b>Email</b>
                    </TableCell>


                  </TableRow>
                </TableHead>

                <TableBody
                  sx={{ paddingBottom: "10px" }}
                  style={{ textAlign: "center" }}
                >
                  {paginatedUsers.map((user) => (

                    <TableRow key={user.Username}>
                      <TableCell align="left"
                        style={{
                          textAlign: "left",

                          marginRight: 5,

                          fontSize: 14,
                        }}
                        fontWeight={500}
                        color="text.secondary"
                      >
                        <a href='#' onClick={() => handleNameClick(user.email)} ><p className='text-short'>{user.Username} </p></a>
                      </TableCell>

                      <TableCell
                        align="left"
                        style={{
                          textAlign: "left",

                          marginRight: 5,

                          fontSize: 14,
                        }}
                        fontWeight={500}
                        color="text.secondary"
                      >
                        {user["nickname"]}
                      </TableCell>

                      <TableCell
                        align="left"
                        style={{
                          textAlign: "left",

                          marginRight: 5,

                          fontSize: 14,
                        }}
                        fontWeight={500}
                        color="text.secondary"
                      >
                        {user["email"]}
                      </TableCell>
                    </TableRow>
                  ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              colSpan={3}
              component="div"
              count={filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Box>
      </Card>
    </div>
  );
};

export default Dashboard;
